import Value from './Value'

export default Value
